import { IPublicClientApplication, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import {
  MsalInterceptorConfiguration,
  MsalGuardConfiguration
} from '@azure/msal-angular';


const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: "bc2e84c7-4c14-49ed-a93e-103c934399c6",
      authority: "https://login.microsoftonline.com/36da45f1-dd2c-4d1f-af13-5abe46b99921",
      redirectUri: window.location.origin,
      // postLogoutRedirectUri: "http://0.0.0.0:4200/"
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: isIE,
    },
    system: {
      allowNativeBroker: false, // Disables native brokering support
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set("https://graph.microsoft.com/v1.0/me", ["user.read"])
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  }
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read']
    }
  }
}

